import React, { Component } from 'react'

export default class InfoTable extends Component {
    constructor(props){
        super(props);
        this.state={
            secondColumn: this.props.secondColumn
        }
        this.secondColumn = this.secondColumn.bind(this);
    }

    secondColumn(){
        if(this.state.secondColumn === true){return (
            
            <div className='floatTextRight' style={{display:'inherit'}}>  
                    <div className='overTC'>
                        <div className='tdBold'>
                            {this.props.Title6}
                        </div>
                        <div className='tdBold'>
                            {this.props.Title7}
                        </div>
                        <div className='tdBold'>
                            {this.props.Title8}
                        </div>
                        <div className='tdBold'>
                            {this.props.Title9}
                        </div>
                        <div className='tdBold'>
                            {this.props.Title10}
                        </div>
                    </div>

                    <div className='overTC'>
                        <div className='tdBold'>
                            {this.props.Result6}
                        </div>
                        <div className='tdBold'>
                            {this.props.Result7}
                        </div>
                        <div className='tdBold'>
                            {this.props.Result8}
                        </div>
                        <div className='tdBold'>
                            {this.props.Result9}
                        </div>
                        <div className='tdBold'>
                            {this.props.Result10}
                        </div>
                    </div>
            </div> 

         )} else return null
    }
    render() {
        return (
            <div className='containerMenu' id='movimenti'>

                <div className='floatTextLeft' style={{display:'inherit'}}>
                        <div className='overTC'>
                            <div className='tdBold'>
                                {this.props.Title1}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title2}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title3}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title4}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title5}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title6}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title7}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title8}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title9}
                            </div>
                            <div className='tdBold'>
                                {this.props.Title10}
                            </div>
                        </div>
                        <div className='overTCExt'>
                            <div className='tdBold'>
                                {this.props.Result1}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result2}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result3}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result4}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result5}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result6}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result7}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result8}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result9}
                            </div>
                            <div className='tdBold'>
                                {this.props.Result10}
                            </div>
                        </div>
                </div> 
                
                    {/*this.secondColumn()*/}
          
            </div>
        )
    }
}
